module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isLoading) ? _c('loader') : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.siteTrsList.length > 0),
      expression: "siteTrsList.length > 0"
    }],
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("Site TRS")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10 text-label"
  }, [_vm._v("\r\n            " + _vm._s(_vm.siteTrsList.join(', ')) + "\r\n        ")])]), _vm._v(" "), (_vm.historicalTrs.length > 0 && _vm.productionAdminEdit) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("Historical TRS")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10 text-label"
  }, _vm._l((_vm.historicalTrs), function(trs) {
    return _c('tr', {
      key: trs.historicalTrsDate,
      staticStyle: {
        "background-color": "#edf0f2"
      }
    }, [_c('td', [_vm._v(_vm._s(trs.historicalTrsDate) + ":  " + _vm._s(trs.plssLocationDisplay))])])
  }))]) : _vm._e(), _vm._v(" "), (_vm.productionAdminEdit) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label text-label",
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "for": "isInsufficientLocationInfo"
    }
  }, [_vm._v("Insufficient Location Information")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.location.isInsufficientLocationInfo),
      expression: "location.isInsufficientLocationInfo"
    }],
    staticClass: "form-check-input",
    staticStyle: {
      "width": "15px",
      "height": "15px"
    },
    attrs: {
      "type": "checkbox",
      "id": "isInsufficientLocationInfo"
    },
    domProps: {
      "checked": Array.isArray(_vm.location.isInsufficientLocationInfo) ? _vm._i(_vm.location.isInsufficientLocationInfo, null) > -1 : (_vm.location.isInsufficientLocationInfo)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.location.isInsufficientLocationInfo,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.location.isInsufficientLocationInfo = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.location.isInsufficientLocationInfo = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.location, "isInsufficientLocationInfo", $$c)
        }
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Street Address")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5",
    class: {
      'form-inline': _vm.qaqcEnabled
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.location.streetAddress),
      expression: "location.streetAddress"
    }],
    staticClass: "form-control",
    style: (_vm.qaqcInputStype),
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.location.streetAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.location, "streetAddress", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.qaqcEnabled) ? _c('qaqcFormFieldSelect', {
    attrs: {
      "fieldData": _vm.qaqcSelection,
      "fieldName": 'streetAddress',
      "hasAppend": true
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('label', {
    staticClass: "col-md-1 control-label"
  }, [_vm._v("Town")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    class: {
      'form-inline': _vm.qaqcEnabled
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.location.town),
      expression: "location.town"
    }],
    staticClass: "form-control",
    style: (_vm.qaqcInputStype),
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.location.town)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.location, "town", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.qaqcEnabled) ? _c('qaqcFormFieldSelect', {
    attrs: {
      "fieldData": _vm.qaqcSelection,
      "fieldName": 'town',
      "hasAppend": true
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Lot-Block")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5",
    class: {
      'form-inline': _vm.qaqcEnabled
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.location.lotBlock),
      expression: "location.lotBlock"
    }],
    staticClass: "form-control",
    style: (_vm.qaqcInputStype),
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.location.lotBlock)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.location, "lotBlock", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.qaqcEnabled) ? _c('qaqcFormFieldSelect', {
    attrs: {
      "fieldData": _vm.qaqcSelection,
      "fieldName": 'lotBlock',
      "hasAppend": true
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('label', {
    staticClass: "col-md-1 control-label"
  }, [_vm._v("Parcel")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    class: {
      'form-inline': _vm.qaqcEnabled
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.location.parcel),
      expression: "location.parcel"
    }],
    staticClass: "form-control",
    style: (_vm.qaqcInputStype),
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.location.parcel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.location, "parcel", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.qaqcEnabled) ? _c('qaqcFormFieldSelect', {
    attrs: {
      "fieldData": _vm.qaqcSelection,
      "fieldName": 'parcel',
      "hasAppend": true
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Access Notes")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [(_vm.qaqcEnabled) ? _c('qaqcFormFieldSelect', {
    attrs: {
      "fieldData": _vm.qaqcSelection,
      "fieldName": 'accessNotes',
      "hasAppend": true
    }
  }) : _vm._e(), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.location.accessNotes),
      expression: "location.accessNotes"
    }],
    staticClass: "form-control",
    style: (_vm.qaqcInputStype),
    attrs: {
      "rows": "6"
    },
    domProps: {
      "value": (_vm.location.accessNotes)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.location, "accessNotes", $event.target.value)
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Datum")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    class: {
      'form-inline': _vm.qaqcEnabled
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.location.datumId),
      expression: "location.datumId",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    style: (_vm.qaqcInputStype),
    attrs: {
      "name": "Datum"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return _vm._n(val)
        });
        _vm.$set(_vm.location, "datumId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Select Datum")]), _vm._v(" "), _vm._l((_vm.datumList), function(datum) {
    return _c('option', {
      key: datum.id,
      domProps: {
        "value": datum.id
      }
    }, [_vm._v("\r\n                    " + _vm._s(datum.description) + "\r\n                ")])
  })], 2), _vm._v(" "), (_vm.qaqcEnabled) ? _c('qaqcFormFieldSelect', {
    attrs: {
      "fieldData": _vm.qaqcSelection,
      "fieldName": 'datumId'
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }), _vm._v(" "), _c('label', {
    staticClass: "col-md-1 control-label"
  }, [_vm._v("Easting")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    class: {
      'form-inline': _vm.qaqcEnabled
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.location.easting),
      expression: "location.easting"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        validUtm: [_vm.location.utmZoneId, 'Easting']
      }),
      expression: "{validUtm: [location.utmZoneId, 'Easting']}"
    }],
    staticClass: "form-control",
    style: (_vm.qaqcInputStype),
    attrs: {
      "type": "text",
      "name": "easting",
      "data-vv-delay": "1000"
    },
    domProps: {
      "value": (_vm.location.easting)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.location, "easting", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('easting')),
      expression: "errors.has('easting')"
    }],
    staticClass: "has-error"
  }, [_vm._v(_vm._s(_vm.errors.first('easting')))]), _vm._v(" "), (_vm.qaqcEnabled) ? _c('qaqcFormFieldSelect', {
    attrs: {
      "fieldData": _vm.qaqcSelection,
      "fieldName": 'easting'
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("UTM Zone")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    class: {
      'form-inline': _vm.qaqcEnabled
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.location.utmZoneId),
      expression: "location.utmZoneId",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    style: (_vm.qaqcInputStype),
    attrs: {
      "name": "UTMZone"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return _vm._n(val)
        });
        _vm.$set(_vm.location, "utmZoneId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Select UTM Zone")]), _vm._v(" "), _vm._l((_vm.utmList), function(utm) {
    return _c('option', {
      key: utm.id,
      domProps: {
        "value": utm.id
      }
    }, [_vm._v("\r\n                    " + _vm._s(utm.description) + "\r\n                ")])
  })], 2), _vm._v(" "), (_vm.qaqcEnabled) ? _c('qaqcFormFieldSelect', {
    attrs: {
      "fieldData": _vm.qaqcSelection,
      "fieldName": 'utmZoneId'
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }), _vm._v(" "), _c('label', {
    staticClass: "col-md-1 control-label"
  }, [_vm._v("Northing")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    class: {
      'form-inline': _vm.qaqcEnabled
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.location.northing),
      expression: "location.northing"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        validUtm: [_vm.location.utmZoneId, 'Northing']
      }),
      expression: "{validUtm: [location.utmZoneId, 'Northing']}"
    }],
    staticClass: "form-control",
    style: (_vm.qaqcInputStype),
    attrs: {
      "type": "text",
      "name": "northing",
      "data-vv-delay": "1000"
    },
    domProps: {
      "value": (_vm.location.northing)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.location, "northing", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('northing')),
      expression: "errors.has('northing')"
    }],
    staticClass: "has-error"
  }, [_vm._v(_vm._s(_vm.errors.first('northing')))]), _vm._v(" "), (_vm.qaqcEnabled) ? _c('qaqcFormFieldSelect', {
    attrs: {
      "fieldData": _vm.qaqcSelection,
      "fieldName": 'northing'
    }
  }) : _vm._e()], 1)]), _vm._v(" "), (!(_vm.qaqcEnabled || _vm.formDisabled)) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-primary pull-right",
    on: {
      "click": _vm.saveLocation
    }
  }, [_vm._v("Save")])])]) : _vm._e(), _vm._v(" "), (_vm.qaqcEnabled) ? _c('qaqcFormFieldFooter', {
    attrs: {
      "qaqcProgressDto": _vm.qaqcProgressDto,
      "qaqcSelection": _vm.qaqcSelection,
      "sectionName": 'location',
      "completeSection": _vm.completeSection
    }
  }) : _vm._e()], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7eb83886"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SiteForm/LocationForm.vue
// module id = 969
// module chunks = 1